// 通用方法
import { message } from 'antd';
import clipboardCopy from 'clipboard-copy';


//! 返回顶部
export function top(duration = 500) {
  const scrollStep = -window.scrollY / (duration == 0 ? 1 : duration / 15);
  let scrollInterval;

  function step() {
    if (window.scrollY === 0) {
      clearInterval(scrollInterval);
    } else {
      window.scrollBy(0, scrollStep);
    }
  }

  scrollInterval = setInterval(step, 15);
}


// 用来截取地址参数的
export function searchUrl(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg);
  return r
}


// 当前是什么端，什么类型
export function pageType() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) return 'android'
  if (isiOS) return 'ios'
  return 'pc'
}



/**
 * 用来截取？后面的参数 
 * @param {string} url  要截取的第地址: https://xxx.com/?id=1
 * @param {string} variable  参数名: 例如:id
 * @returns 
 */
export function getQueryVariable(url, variable) {
  var query = url?.split("?")[1]; // 根据“?”切割数组，截取“?”之后的字符串
  if (!query) return
  // ['https://qq.com','appid=1234567890&name=Tom']
  var vars = query?.split("&"); // 根据“&”切割成数组
  // ['appid=1234567890','name=Tom']
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i]?.split("=");
    // ['appid','1234567890']
    if (pair[0] == variable) return pair[1]; // 没有花括号默认执行第一个js语句
  }
  return;
}



export function copyText(text, tips) {
  const textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
  textarea.value = text;

  // 将 textarea 添加到 DOM 中
  document.body.appendChild(textarea);

  // 选中文本
  textarea.select();

  // 尝试执行复制命令
  const successful = document.execCommand('copy');

  // 清理并移除 textarea
  document.body.removeChild(textarea);
  alert(successful)

  if (successful) {
    message.success(tips ? tips : '复制成功')
  } else {
    // alert('复制失败，请手动复制文本');
  }
}

